import * as React from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

// const label = { inputProps: { "aria-label": "Checkbox demo" } };

export default function ColorCheckboxes({
  defaultChecked,
  checked,
  handleChange,
  labelText,
  name,
  value,
}) {
  return (
    <FormControlLabel
      control={
        <Checkbox
          // {...label}
          name={name}
          value={!value}
          checked={checked}
          onChange={handleChange}
          defaultChecked={defaultChecked}
          sx={{
            color: "#7747c3",
            "&.Mui-checked": {
              color: "#f8c129",
            },
          }}
        />
      }
      label={labelText}
    />
  );
}
